import { CountryCodeJson } from '../jsonData';
import { countryCode } from '../services/thirdParty/citiesNowApi';

const phoneCodeMap = new Map();
const countryNameMap = new Map();

CountryCodeJson.forEach(country => {
    phoneCodeMap.set(country.dial_code, country.code.toLowerCase());
    countryNameMap.set(country.name.toLowerCase(), country.code.toLowerCase());
});

export const dynamicTimeZone = () => {
    return "Asia/Bangkok"
}

export const getPhoneCode = async (phone_code) => {
    const currentCountry = sessionStorage.getItem('country');

    console.log('phone_code -------:', phone_code)
    if (phone_code) {

        const countryCode = phoneCodeMap.get(phone_code);
        if (countryCode) {
            console.log('return value inside phone code if condition -------:', countryCode)
            return countryCode;
        }
    }
    else if ((currentCountry) && (currentCountry !== 'undefined')) {
        try {
            const response = await countryCode(currentCountry);
            console.log('return value inside the currentCountry -------:', response?.toLowerCase())

            return response?.toLowerCase();
        }
        catch (err) {
            console.log('return value inside catch -------:', 'th')

            return 'th';
        }
    }
    console.log('return value inside outer -------:', 'th')

    return 'th';
};


export const getDefaultCountryCode = () => {
    const isIndiaCountry = sessionStorage.getItem('country') === 'India';
    if (isIndiaCountry) {
        return '+91'
    }
    return '+66'
}